@import url(../../common/css/base.css);

.jackery-comment-overview_overview_title {
  font-size: 24px;
  margin-bottom: 20px;
  margin-top: 5px;
  color: #2d2d2d;
  font-weight: bold;
}

.jackery-comment-overview_overview_line {
  margin-bottom: 20px;
  margin-top: 16px;
  border-bottom: solid 1px #d4d4d4;
}

.jackery-comment-overview_rating_inner {
  margin: 40px 0 27px 0;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
}

.jackery-comment-overview_rating_item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0.9px dashed #d4d4d4;
}
.jackery-comment-overview_rating_item:last-child {
  border-right: none;
}

.jackery-comment-overview_average_rating_box {
  line-height: 0.6;
  text-align: left;
  margin-bottom: 8px;
}
.jackery-comment-overview_average_rating {
  font-size: 64px;
  font-weight: bold;
  color: #fdcc0d;
}
.jackery-comment-overview_total_rating {
  vertical-align: top;
  position: relative;
  top: 12px;
  font-weight: bold;
  font-size: 18px;
  color: #3f3f3f;
}

.jackery-comment-overview_total_reviews {
  margin-top: 2px;
  font-size: 12px;
  color: #3f3f3f;
}

.review_rate_section {
  padding: 0 40px;
  align-items: flex-end;
}

.areviews_rating_filter {
  margin-bottom: 4px;
  cursor: pointer;
  transition: all .3s;
}
.areviews_rating_filter:last-child {
  margin-bottom: 0;
}
.areviews_rating_filter>.flex {
  height: 20px;
  font-size: 14px;
  color: #fdcc0d;
}
.areviews_rating_filter.active>.flex {
  color: #fd5000;
}

.icon-star {
  width: 18px;
  height: 20px;
  line-height: 20px;
  padding-left: 2px;
}
.icon-star svg path {
  fill: #9c9c9c;
}

.progress_bar_con {
  width: 140px;
  height: 12px;
  background-color: #d8d8d8;
  margin-left: 8px;
  position: relative;
}
.progress_bar_inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fdcc0d;
  transform-origin: left center;
  transform: scaleX(var(--percent));
  transition: all .2s;
}
.areviews_rating_filter.active .progress_bar_inner {
  background: #fd5000;
}
.progress_bar_con.no_reviews {
  background-color: #d8d8d8;
}

.total_reviews_number_Rating {
  color: #fdcc0d;
  transition: all .2s;
}
.areviews_rating_filter.active .total_reviews_number_Rating {
  color: #fd5000;
}
.total_reviews_number_Rating span {
  display: inline-block;
  font-size: 14px;
  width: 50px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
  border: 1px solid #efefef;
  border-radius: 12px;
}

.jackery-comment-overview {
  position: relative;
}
jackery-dropdown {
  position: absolute;
  bottom: 0;
  right: 0;
}
.sort-box {
  position: relative;
  cursor: pointer;
  height: 36px;
  transition: color .3s;
}
.sort-box button {
  font-size: 14px;
  font-weight: bold;
  color: #000;
  transition: all .3s;
  cursor: pointer;
  outline: 0;
  border: none;
  background: none;
  gap: 20px;
}
.sort-box:hover button {
  color: #fd5000;
}
.sort-box svg {
  padding-top: 2px;
}
.sort-box:hover svg path {
  stroke: #fd5000;
}
.sort-box svg path {
  stroke: #666;
}


.enter_reviews {
  overflow: hidden;
  transition: all 0.25s;
  max-height: 0;
}
.enter_reviews.active {
  max-height: 600px;
}



/* form */
.form-line-item {
  flex-direction: column;
  margin: 0 0 1em;
  color: #3f3f3f;
}
.form-line-item label {
  font-size: 14px;
  color: #3f3f3f;
  padding-bottom: 2px;
}
.form-line-item input[type=text] {
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 0.5em;
    border: 1px solid #cacaca;
    border-radius: 3px;
    background-color: #fefefe;
    box-shadow: inset 0 1px 2px rgba(10,10,10,.1);
    font-family: inherit;
    font-weight: 400;
    color: #0a0a0a;
    transition: box-shadow .5s,border-color .25s ease-in-out;
    appearance: none;
    max-width: 100%;
    outline: 0;
    font-size: 14px;
}
.form-line-item.error input[type=text], .form-line-item.error textarea {
  border-color: #ff4d4f;
}
.form-line-item.error .line-item-error {
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  transform-origin: top center;
  color: #ff4d4f;
  animation: heightAnimation 0.3s ease-in-out;
}
@keyframes heightAnimation {
  from {
    transform: scaleY(0);
  }
  to {
    transform: scaleY(1);
  }
}
.form-line-item input:hover {
  border-color: #4096ff;
  border-inline-end-width: 1px;
}
.form-line-item input:focus {
  box-shadow: 0 0 0 2px rgba(5,145,255,.1);
}
.form-line-item.error input:hover {
  border-color: #ff4d4f;
}

.form-line-item__star {
  flex-direction: row;
  align-items: baseline;
}
.form-line-item__star label {
  padding-right: 14px;
}
.line-item__score {
  padding-left: 4px;
  font-size: 14px;
}
.line-item__score span {
  color: #999;
}


.form-line-item__area {
  width: 100%!important;
  max-height: 210px!important;
}
.form-line-item__area textarea {
  display: block;
  border-radius: 4px;
  border: 1px solid #cacaca;
  outline: none;
  transition: box-shadow .5s,border-color .25s ease-in-out;
  padding: 8px;
  width: 97%!important;
  max-height: 200px!important;
}
.form-line-item__area textarea:hover {
  border-color: #4096ff;
  border-inline-end-width: 1px;
}
.form-line-item.error textarea:hover {
  border-color: #ff4d4f;
}
/* form */


@media screen and (max-width: 1024px) {
  .jackery-comment-overview_rating_container {
    padding: 0 20px;
  }
  .jackery-comment-overview_rating_inner {
    flex-direction: column;
  }
  .review_rate_section {
    padding: 0;
  }

  .jackery-comment-overview_rating_item {
    border: none;
  }

  .areviews_rating_filter {
    width: 100%;
  }

  .progress_bar_con {
    width: unset;
    flex: 1;
  }

  .form-line-item__area textarea {
    width: 94%!important;
  }
}

.line-item-error__rating {
  margin: -16px 0 2px 0;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
  transform-origin: top center;
  color: #ff4d4f;
  animation: heightAnimation 0.3s ease-in-out;
}